import StarterKit from '@tiptap/starter-kit';
import { Link } from '@tiptap/extension-link';
import { isAllowedLinkUrl } from './checklistDescription';

// The backend only accepts href, target and rel on links, so never carry a class through.
const DescriptionLink = Link.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			class: { default: null, parseHTML: () => null, renderHTML: () => ({}) },
		};
	},
});

const descriptionExtensions = [
	StarterKit.configure({
		heading: false,
		bulletList: false,
		orderedList: false,
		listItem: false,
		blockquote: false,
		codeBlock: false,
		code: false,
		horizontalRule: false,
		strike: false,
	}),
	DescriptionLink.configure({
		openOnClick: false,
		// Pasting a URL over a selection would link it even when the URL isn't allowed.
		linkOnPaste: false,
		isAllowedUri: url => isAllowedLinkUrl(url),
	}),
];

export default descriptionExtensions;
